import { useTranslation } from "react-i18next"

const lambdafy = (x) => (typeof x === "function" ? x : () => x)

const StaticFields = ({ data, setShow }) => {
  const toggleShow = () => setShow((c) => !c)
  return (
    <>
      <span onClick={toggleShow}>x</span>
      {data.comentario}
      <hr className="my-1" />✅ <i>{data.correccion}</i>
    </>
  )
}

const DynmFields = ({ data, setData, setShow, handleDelete, handleSave }) => {
  const toggleShow = () => setShow((c) => !c)
  const { t } = useTranslation()

  const handleIO = (callback) => {
    callback(data)
    setShow(false)
  }

  return (
    <>
      <span onClick={toggleShow}>x</span>

      <b>{t("ui.texts.comment")}</b>
      <br />

      <input
        type="text"
        className="form-control form-control-sm"
        placeholder="Escribe un comentario aquí"
        onChange={(e) => setData((c) => ({ ...c, comentario: e.target.value }))}
        value={data.comentario}
      />

      <br />

      <b>✅ {t("ui.texts.correction")}</b>
      <br />

      <input
        type="text"
        className="form-control form-control-sm"
        placeholder="Escribe una corrección aquí"
        onChange={(e) => setData((c) => ({ ...c, correccion: e.target.value }))}
        value={data.correccion}
      />

      <div className="d-flex row-flex justify-content-center mt-3">
        <button
          type="button"
          onClick={() => handleIO(handleSave)}
          className="btn btn-primary btn-sm">
          {t("ui.btns.save")}
        </button>
        <button
          onClick={handleDelete}
          type="button"
          className="btn btn-danger btn-sm ms-1">
          {t("ui.btns.delete")}
        </button>
      </div>
    </>
  )
}

export const Marca = ({
  marca,
  editable = false,
  setData,
  handleDelete,
  handleSave,
}) => {
  const setShow = (callback) => {
    setData((current) => ({
      ...current,
      show: lambdafy(callback)(current.show),
    }))
  }

  return (
    <>
      <div className="d-inline-flex position-relative">
        {
          <div
            className="popover"
            style={{ display: marca.show ? "block" : "none" }}>
            {!editable && (
              <StaticFields
                setShow={setShow}
                data={marca} // <--- diferentes nombres de campos
              />
            )}
            {editable && (
              <DynmFields
                setShow={setShow}
                data={marca} // <--- diferentes nombres de campos
                setData={setData}
                handleSave={handleSave}
                handleDelete={handleDelete}
              />
            )}
          </div>
        }
        <mark onClick={() => setShow((c) => !c)}>{marca.seleccion}</mark>
      </div>
    </>
  )
}
